export default "__VITE_ASSET__CLptS1F2__"